module.exports = "/v2/pages/dashboard/dist/75e5f213ae3f2386c1f37c7cdea93f18.svg";